class StoreStockDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#StoreStock-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.form = document.getElementById('store-stock-form');
  }

  setHeaderCartIconAccessibility() {
    this.btn = document.querySelector('#btn-store-stock');
    this.btn.setAttribute('role', 'button');
    this.btn.setAttribute('aria-haspopup', 'dialog');
    this.btn.addEventListener('click', (event) => {
      this.loadData(event)
    });

    this.btn.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        this.loadData(event);
      }
    });
  }

  loadData(evt) {
    evt.preventDefault();
    if (this.btn.getAttribute('aria-disabled') === 'true') return;

    this.btn.setAttribute('aria-disabled', true);
    this.btn.classList.add('loading');
    this.btn.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    //const config = fetchConfig('json');
    const config = {
      method: 'POST',
      headers: { 'Content-Type': 'text/html', 'Accept': `text/html` }
    }

    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    formData.append('sections', this.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);

    this.setActiveElement(this.btn);
    config.body = formData;

    fetch(this.form.action, config)
        .then((response) => response.text())
        .then((response) => {
          this.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.btn.classList.remove('loading');
          this.btn.removeAttribute('aria-disabled');
          this.btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = document.getElementById('StoreStockDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }


  renderContents(parsedState) {
    //this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');

    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML = parsedState;
    }));

    setTimeout(() => {
      this.querySelector('#StoreStock-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'storestock-wrapper'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('store-stock-drawer', StoreStockDrawer);
